export interface CryptoTickerOption {
	value: string;
	label: string;
	isComposite: boolean;
}

export interface ChainOption {
	value: string;
	label: string;
}

export interface FiatOption {
	value: string;
	label: string;
}

export const CRYPTO_TICKER_OPTIONS: CryptoTickerOption[] = [
	{ value: "BTC", label: "BTC", isComposite: false },
	{ value: "ETH", label: "ETH", isComposite: false },
	{ value: "ETH_USDT", label: "ETH USDT", isComposite: true },
	{ value: "ETH_USDC", label: "ETH USDC", isComposite: true },
	{ value: "BNB", label: "BNB", isComposite: false },
	{ value: "BSC_USDT", label: "BSC USDT", isComposite: true },
	{ value: "MATIC", label: "MATIC", isComposite: false },
	{ value: "MATIC_USDT", label: "MATIC USDT", isComposite: true },
	{ value: "MATIC_USDC", label: "MATIC USDC", isComposite: true },
	{ value: "TRON", label: "TRON", isComposite: false },
	{ value: "TRON_USDT", label: "TRON USDT", isComposite: true },
];

export const CHAIN_SHORT_OPTIONS: ChainOption[] = [
	{ value: "BTC", label: "Bitcoin" },
	{ value: "ETH", label: "Ethereum" },
	{ value: "MATIC", label: "Polygon" },
	{ value: "BSC", label: "BNB Chain" },
	{ value: "TRON", label: "TRON" },
];

export const FIAT_OPTIONS: FiatOption[] = [
	{ value: "USD", label: "USD" },
	{ value: "EUR", label: "EUR" },
];
